import React from 'react';
import {Panel, Col, Row, Glyphicon} from 'react-bootstrap'
import {Link} from 'react-router-dom'
import classnames from 'classnames';
import ArrowButton from '../common/button-arrow'

const Store = ({store, open, row, onManageClicked}) => {
  const details = `/store-details/${store.id}`;
  const manage = `/staff-rewards/${store.id}/manage`;
  const panelFooter = (
    <Row className="staff-rewards-manage-container">
      <Col md={12}>
        <ArrowButton color="white"
                      ghost
                      className="manage-staff-rewards-button"
                      arrow={false}
                      submit={false}
                      onClick={() => onManageClicked(store.id, row)}>
          <Glyphicon glyph="pencil"/>Manage
        </ArrowButton>
      </Col>
    </Row>
  );
  const panelHeader = (
    <div>
        <div className="staff-rewards-store-name">{store.attributes.name}</div>
        <div className="staff-rewards-customer-number">{store.attributes['customer-number']}</div>
    </div>
  );


  return (
    <Col md={4}>
      <Panel className={classnames('staff-rewards-store-item', {open: open})} footer={panelFooter} header={panelHeader}>
        <p>Number Of Staff<span className="staff-number">{store.attributes['num-of-staff'] || 0}</span></p>
        <Link to={details}>
          <ArrowButton color="red"
                      className="btn-block staff-rewards-details-button"
                      arrow={false}
                      submit={false}>Details</ArrowButton>
        </Link>
      </Panel>
    </Col>
  );
};

export default Store;



// WEBPACK FOOTER //
// ./src/components/staff-rewards/store.jsx